import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
// Sections for this page
import Info from "views/MainPage/Sections/Info.js";

import bhaktapur_image1 from "assets/img/bhaktapur/bhaktapur/image1.jpg";
import bhaktapur_image2 from "assets/img/bhaktapur/bhaktapur/image2.jpg";
import changunarayan_image1 from "assets/img/bhaktapur/changunarayan/image1.jpg";
import changunarayan_image2 from "assets/img/bhaktapur/changunarayan/image2.jpg";
import madhyapur_thimi_image1 from "assets/img/bhaktapur/madhyapur_thimi/image1.jpg";
import madhyapur_thimi_image2 from "assets/img/bhaktapur/madhyapur_thimi/image2.jpg";
import suryabinayak_image1 from "assets/img/bhaktapur/suryabinayak/image1.jpg";
import suryabinayak_image2 from "assets/img/bhaktapur/suryabinayak/image2.jpg";

const useStyles = makeStyles(styles);

export const info = {
  bhaktapur: {
    title:"परिचय",
    name:"भक्तपुर नगरपालिका",
    content:"स्थानीय नेवारी भाषामा ख्वप नामले चिनिने भक्तपुर काठमाण्डौ उपत्यकाको पूरानो नेवारी साँस्कृतिक केन्द्र हो । यो नगर नेपालको राजधानी काठमाण्डौबाट १५ कि.मी. पूर्वमाअवस्थित छ । भक्तपुरको पूर्वमा काभ्रे जिल्ला उत्तर पूर्वमा काठमाण्डौ जिल्ला र दक्षिणमा ललितपुर जिल्ला पर्दछ । यो नगर समुद्री सतहबाट १४०१ मीटर माथि अवस्थित छ । यस नगर ६.८८ वर्ग कि.मी. फैलिएको छ । यस नगरमा ९० प्रतिशतभन्दा बढी नेवार र बाँकी ब्राम्हण, मुस्लिम र अन्यजातिहरु बसोबास गर्दछन् । वि.सं. २०६८ सालको जनगणना अनुसार भक्तपुर जिल्लामा ३०४६५१ र ऐतिहासिकनगरी भक्तपुरमा ८३६५८ जनसंख्याबसोबास गर्दछन् । यहाँका सम्पदा संरक्षणलाई प्रशंसा गर्दै युनेस्कोले यस शहरलाई सन् १९७९ माविश्व सम्पदा सूचीमा सूचीकृत गरियो । नेपालको लिखित ईतिहास भक्तपुरको चाँगुनारायण बाट शुरु हुन्छ । जुजु धौ, भादगाउँले टोपी, हाकु पटासी, माटोको भाँडाकुडा र हस्तकला आदीले भक्तपुर नगरको परिचय र मौलिकता झल्काउँछ ।",
    images:[{
        image: bhaktapur_image1,
        image_description: "भक्तपुर नगरपालिका"
      },{
        image: bhaktapur_image2,
        image_description: "भक्तपुर नगरपालिका"
    }]
  },
  changunarayan: {
    title:"परिचय",
    name:"चाँगुनारायण नगरपालिका",
    content:"ऐतिहासिक एवं पुरातात्विक महत्वको दृष्टीकोणले परिचित भक्तपुर जिल्ला भित्रका ४ वटा नगरपालिका मध्ये चाँगुनारायण नगरपालिका नेपाल सरकारले मिति २०७३ ११ २७ गतेको स्थानिय तह घोषणाबाट साविक चाँगुनारायण नगरपालिका र नगरकोट नगरपालिकालाई समेटेर गठन भएको हो । मिति २०७१ ८ १६ को मन्त्रीपरिषदको निर्णय अनुसार साविक चाँगुनारायण, झौखेल, छालिड, दुवाकोट गा.वि.स समेटेर चाँगुनारायण नगरपालिका तथा साविक नगरकोट बागेश्वरी, सुडाल र ताथली गा.वि.स समेटेर महामन्जुश्री नगरकोट नगरपालिका घोषणा भएको थियो । पछि महामन्जुश्री नगरकोट नगरपालिका मिलाएर नाम संशोधन भै नगरकोट नगरपालिका कायम भयो । चाँगुनारायण नगरपालिका र  नगरकोट नगरपालिका मिलाएर चाँगुनारायण नगरपालिका भए पछि ९ वटा वडा कायम भई नगरपालिकाको केन्द्र खरिपाटी, भक्तपुरमा रहेको छ ।",
    images:[{
        image: changunarayan_image1,
        image_description: "चाँगुनारायण नगरपालिका"
      },{
        image: changunarayan_image2,
        image_description: "चाँगुनारायण नगरपालिका"
    }]
  },
  madhyapur_thimi: {
    title:"परिचय",
    name:"मध्यपुर थिमि नगरपालिका",
    content:"भक्तपुर जिल्ला, ३ नं. प्रदेश अन्तर्गत पर्ने मध्यपुर थिमि नगरपालिकाको गठन वि.स. २०५३ साल चैत्र १४ गते तत्कालिन बोडे, नगदेश, चपाचो, बालकुमाारी र दिव्यश्वरी गाउँ विकास समितिहरुलाई एक आपसमा गाभी बनाइएको हो । तत्कालीन अवस्थामा स्थानीय निकायको रुपमा रहेको यस मध्यपुर थिमि नगरपालिकामा १७ वटा वडा भएकोमा नयाँ संविधानको प्रावधान बमोजिम स्थानीय तहको रुपमा गठन हुँदा ९ वटा वडा कायम भएको छ । यस नगरको पूर्वमा भक्तपुर र चाँगुनारायण नगरपालिका, पश्चिममा काठमाडौ महानगरपालिकाको सिनामंगल, उत्तरमा कागेश्वरी मनोहरा नगरपालिका र दक्षिणमा सुर्यबिनायक नगरपालिका र महालक्ष्मी नगरपालिका पर्दछन् । विश्व मान चित्रमा यो नगरपालिका २७०४०’ देखि २७०४२’ उत्तरी अक्षांशसम्म र ८१०२२’३०” पूर्व देखि ८५०२५’०” देशान्तरसम्म फैलिएर रहेको छ ।",
    images:[{
        image: madhyapur_thimi_image1,
        image_description: "मध्यपुर थिमि नगरपालिका"
      },{
        image: madhyapur_thimi_image2,
        image_description: "मध्यपुर थिमि नगरपालिका"
    }]
  },
  suryabinayak: {
    title:"परिचय",
    name:"सूर्यविनायक नगरपालिका",
    content:"भक्तपुर नगरबाट २ कि.मी. दक्षिण साविक सिपाडोल गा.वि.स मा पर्ने सुर्यविनायक क्षेत्र धार्मिक एवं ऐतिहासिक दृष्टिकोणबाट अति महत्वपुर्ण छ । यहाँको प्रसिद्ध सुर्य विनायक (गणेश) मन्दिर लिच्छिवि कालमा शिखरशैलीमा निर्माण भएको पाईन्छ । काठमाँडौ, पाटन, बनेपा, भक्तपुर जिल्लाका भक्तजनहरु हरेक मंगलवार र माघ महिनामा घुइचोका साथ यस गणेश मन्दिरको दर्शनार्थ आउने गरेको पाईन्छ । सुर्य विनायक को पुजाबाट भाग्य निर्माण हुने र सद्वुद्धि आउने आम धारणा रहेको छ । हरीयाली रमणीय डाँडा रहेको कारणले यो क्षेत्र पर्यटकीय एवं पिकनीक स्थलको रुपमा प्रख्यात छ । सुर्य विनायकको जंगलमा ९९ प्रजातिका चराचुरुङ्गी पाइने हुनाले यो स्थलले द्यष्चम ध्बतअजष्लन को लागी पनी क्रमशः प्रसिद्ध पाउदै आएको छ ।",
    images:[{
        image: suryabinayak_image1,
        image_description: "सूर्यविनायक नगरपालिका"
      },{
        image: suryabinayak_image2,
        image_description: "सूर्यविनायक नगरपालिका"
    }]
  }
}

export default function ProductSection() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer style={{ marginTop: '-80px' }}>
        <GridItem xs={12} sm={12} md={12} style={{ textAlign: 'left' }}>
          <Info info={info.bhaktapur} link="intro/bhaktapur" municipality_page={true} />
          <div style={{ backgroundColor: '#eee', paddingRight: '20px', paddingLeft: '20px' }}>
            <Info info={info.changunarayan} link="intro/changunarayan" municipality_page={true} />
          </div>
          <Info info={info.madhyapur_thimi} link="intro/madhyapur_thimi" />
          <div style={{ backgroundColor: '#eee', paddingRight: '20px', paddingLeft: '20px' }}>
            <Info info={info.suryabinayak} link="intro/suryabinayak" municipality_page={true} />
          </div>
        </GridItem>
      </GridContainer>
    </div>
  );
}
